const searchToggleButton = document.getElementById("search-button-mobile-open")
const searchInput = document.getElementById("search-input")

searchToggleButton.addEventListener('click', () => {
  searchInput.classList.toggle('d-none')
})

// window.addEventListener('scroll', () => {
//   searchContainer.classList.remove('Header__Search-Bar-Container--Active')
//   searchBar.classList.remove('Header__Search-Bar-Background--Active')
// })